import { useState } from "react";
import {
  Box,
  Button,
  Modal,
  TextField,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useSendReview } from "@src/entities/rating";

import styles from "./ReviewModal.module.scss";

interface Props {
  open: boolean;
  onClose: () => void;
  userId: number | null;
}

export const ReviewModal = ({ open, onClose, userId }: Props) => {
  const [text, setText] = useState("");
  const { mutate: sendReview } = useSendReview();

  const textLength = text.trim().length;
  const isBtnDisabled = !(textLength >= 20);

  const handleSubmit = async () => {
    if (userId) {
      await sendReview({ user_id: userId, text });
      setText("");
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose} className={styles.modal}>
      <Box className={styles.modalBox}>
        <Typography variant="h6" className={styles.title}>
          Оставить отзыв
        </Typography>

        <IconButton
          size="small"
          onClick={onClose}
          className={styles.close}
          sx={{ position: "absolute", top: 8, right: 8 }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <TextField
          multiline
          rows={4}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Напишите ваш отзыв..."
          fullWidth
          className={styles.textarea}
        />

        {textLength < 20 && (
          <Typography variant="caption" className={styles.textLength}>
            Минимум 20 символов ({textLength}/20)
          </Typography>
        )}

        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          className={styles.submitBtn}
          disabled={isBtnDisabled}
        >
          Отправить
        </Button>
      </Box>
    </Modal>
  );
};
